module.exports = __webpack_public_path__ + "static/media/Pirate Captain.1a4a0ac1.jpg";